import React from "react";

const ProjectCostSection = ({ formData, setFormData }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData("projectCost", {
      ...formData.projectCost,
      [name]: value,
    });
  };

  return (
    <>
      <div className="form-section">
        <h3>Project/Activity Cost</h3>
        <div className="form-group">
          <label>
            Total Cost of the Project at current price level {"(in Lakhs)"}
          </label>
          <input
            type="text"
            value={formData.projectCost.totalCost}
            onChange={handleInputChange}
            name="totalCost"
            placeholder="0"
          />
        </div>
      </div>

      <div className="form-section">
        <h3>Employment likely to be generated</h3>
        <div className="construction-phase">
          <h4>During construction phase</h4>
          <div className="permanent-employment">
            <h5>Permanent employment</h5>
            <div className="form-group">
              <label>No. of permanent employment (No.s) [A]</label>
              <input
                type="text"
                name="constructionPermanentEmployees"
                value={formData.projectCost.constructionPermanentEmployees}
                onChange={handleInputChange}
                placeholder="0"
              />
            </div>

            <div className="form-group">
              <label>Period of employment (No. of days) [B]</label>
              <input
                type="text"
                name="constructionEmploymentPeriod"
                value={formData.projectCost.constructionEmploymentPeriod}
                onChange={handleInputChange}
                placeholder="0"
              />
            </div>

            <div className="form-group">
              <label>No. of man-days [X]=[A]*[B]</label>
              <input
                type="text"
                name="constructionManDays"
                value={formData.projectCost.constructionManDays}
                onChange={handleInputChange}
                placeholder="0"
              />
            </div>
          </div>

          <div className="temporary-employment">
            <h5>Temporary employment</h5>

            <div className="form-group">
              <label>
                Temporary / Contractual employment (No. of Man days) [Y]
              </label>
              <input
                type="text"
                name="constructionTemporaryEmployment"
                value={formData.projectCost.constructionTemporaryEmployment}
                onChange={handleInputChange}
                placeholder="0"
              />
            </div>

            <div className="form-group">
              <label>Total [X] + [Y]</label>
              <input
                type="text"
                name="constructionTotal"
                value={formData.projectCost.constructionTotal}
                onChange={handleInputChange}
                placeholder="0"
              />
            </div>
          </div>
        </div>
        <div className="operation-phase">
          <h4>During operational phase</h4>
          <div className="permanent-employment">
            <h5>Permanent employment</h5>
            <div className="form-group">
              <label>No. of permanent employment (No.s) [A]</label>
              <input
                type="text"
                name="operationPermanentEmployees"
                value={formData.projectCost.operationPermanentEmployees}
                onChange={handleInputChange}
                placeholder="0"
              />
            </div>

            <div className="form-group">
              <label>Period of employment (No. of days) [B]</label>
              <input
                type="text"
                name="operationEmploymentPeriod"
                value={formData.projectCost.operationEmploymentPeriod}
                onChange={handleInputChange}
                placeholder="0"
              />
            </div>

            <div className="form-group">
              <label>No. of man-days [X]=[A]*[B]</label>
              <input
                type="text"
                name="operationManDays"
                value={formData.projectCost.operationManDays}
                onChange={handleInputChange}
                placeholder="0"
              />
            </div>
          </div>

          <div className="temporary-employment">
            <h5>Temporary employment</h5>

            <div className="form-group">
              <label>
                Temporary / Contractual employment (No. of Man days) [Y]
              </label>
              <input
                type="text"
                name="operationTemporaryEmployment"
                value={formData.projectCost.operationTemporaryEmployment}
                onChange={handleInputChange}
                placeholder="0"
              />
            </div>

            <div className="form-group">
              <label>Total [X] + [Y]</label>
              <input
                type="text"
                name="operationTotal"
                value={formData.projectCost.operationTotal}
                onChange={handleInputChange}
                placeholder="0"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectCostSection;
